<template>
  <div class="password-input">
    <ui-v :rules="rules" ref="form">
      <ui-input
        v-model="password"
        name="password"
        type="password"
        :placeholder="$t('typeBookPasswordHere')"
      >
        <ui-icon slot="prefix" name="lock"></ui-icon>
      </ui-input>
    </ui-v>
    <ui-button type="primary" full @click.native="verfiyPassword">{{
      $t("submit")
    }}</ui-button>
  </div>
</template>
<script>
import api from "../api/index";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      password: "",
      rules: {
        password: [
          {
            type: "required",
            trigger: "submit",
            message: this.$t("empty") + this.$t("password")
          }
        ]
      }
    };
  },
  props: ["book"],
  inject: ["reload"],
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    verfiyPassword() {
      this.$refs["form"]
        .validate()
        .then(() => {
          let data = {
            id: this.book.id,
            password: this.password,
            nanoId: localStorage.getItem("nanoId")
          };
          api
            .verfiyPassword(data)
            .then(res => {
              this.$UiToast({
                message: this.$t("passwordCorrect"),
                onClose: () => {
                  this.reload();
                }
              });
            })
            .catch(err => {
              this.$refs["form"].parseError({
                name: "password",
                message: this.$t("wrongAccessCode")
              });
            });
        })
        .catch(() => {});
    }
  }
};
</script>
